const absenceReason = Object.freeze({
  Other: 1,
  SpecialistAbsence: 2,
  CancelByParents: 3,
  CancelBySpecialist: 4,
  SchoolProgrammingChange: 5,
  CantBeContacted: 6,
});

export default absenceReason;
